import PdfPage from "../../components/PdfPage";
import "../index.css";

export default function PSXDownloadsFinal() {
  return (
    <main>
      <PdfPage
        h2={"PSX Investor Guide"}
        img={"/img/PSX-logo.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/psx-investor-guide-english.pdf"}
        pdf1Text={"Download File In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/psx-investor-guide-urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
}
